import axios from 'axios';
import React, { Component } from 'react'
import Cookies from 'universal-cookie';
import { Footer } from '../footer/Footer';
import { NavbarLog } from '../navbar/NavbarLog'
//import "../services/ApiRest"
import './CarrerasScreen.css';
import { ApiUrl } from '../services/ApiRest';
import { Alert } from 'bootstrap';
const baseUrl = ApiUrl + "listcarrvisuest" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const cookies = new Cookies();

export default class CarrerasScreen extends Component {

    constructor(props) {
        super(props);
        this.state = {
            carrera: []
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });
        var idCarrera = this.state.idCarrera;
        cookies.set('idCarrera', idCarrera, { path: "/" });
        window.location.href = "/carrera";
    }

    componentDidMount() {

        axios.get(baseUrl)
            .then(res => {
                const carrera = res.data.data;

                this.setState({ carrera });
            })
    }

    render() {
        return (
            <div className="carreras-page">
                <NavbarLog />

                <div className="bg-gradient-institucional d-flex justify-content-center align-items-center py-5">
                    <div className="row w-100 m-0 p-4" style={{ maxWidth: "1200px" }}>

                        {/* VIDEO */}
                        <div className="col-lg-7 mb-4 mb-lg-0 d-flex justify-content-center align-items-center">
                            <div className="rounded-4 overflow-hidden shadow border w-100">
                                <div className="ratio ratio-16x9">
                                    <iframe
                                        src="https://www.youtube.com/embed/kg57IwGcQX8?autoplay=1&mute=1&loop=1&playlist=kg57IwGcQX8&controls=0&rel=0&modestbranding=1"
                                        title="Video institucional ISTMAS"
                                        allow="autoplay; encrypted-media"
                                        allowFullScreen
                                        style={{ border: 'none' }}
                                    ></iframe>
                                </div>
                            </div>
                        </div>

                        {/* TÍTULO + SELECTOR DE CARRERA */}
                        <div className="col-lg-5 d-flex flex-column justify-content-center">
                            <h2 className="fw-bold mb-4 text-center text-azul">
                                Sistema Académico Institucional
                            </h2>
                            <div className="card shadow-lg p-4 rounded-4 bg-white w-100">
                                <h5 className="fw-semibold text-center mb-3 text-azul" style={{ fontSize: '1.25rem' }}>
                                    CARRERAS ISTMAS
                                </h5>
                                <label className="form-label mb-2 text-muted" style={{ fontSize: '1rem' }}>
                                    Seleccione la carrera que desea inscribirse
                                </label>
                                <select
                                    className="form-select rounded-3"
                                    name="idCarrera"
                                    value={this.state.value}
                                    onChange={this.handleChange}
                                    aria-label="Seleccione una carrera"
                                >
                                    <option value="undefined">Seleccione una carrera</option>
                                    {this.state.carrera.map((person) => (
                                        <option key={person.id_carrera} value={person.id_carrera}>
                                            {person.descripcion_carrera}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                    </div>
                </div>

                <Footer />
            </div>
        )
    }
}
